<template>
  <div class="posts-by-category">
    <div v-for="(cat, index) in categories" :key="cat.id">
      <div v-if="category == cat.id">
        <h2 style="textTransform: uppercase">{{ cat.name }}</h2>
        <div
          class="bar mb-4"
          :style="{ background: STYLES[index].color }"
        ></div>
      </div>
    </div>
    <b-row>
      <b-col cols="12" md="8" class="latest-post mb-4">
        <div>
          <b-link :to="'/' + category + '/' + latestPost.id">
            <figure>
              <b-img
                fluid
                :src="latestPost.imgUrl"
                :alt="latestPost.title"
              ></b-img>
            </figure>
          </b-link>
        </div>
        <div>
          <b-link :to="'/' + category + '/' + latestPost.id">
            <h1 class="title">{{ latestPost.title }}</h1>
            <div class="author-date">
              <ul>
                <li>
                  <strong>{{ latestPost.author }}</strong>
                </li>
                <time>
                  {{ moment(latestPost.createdAt).format("MMMM Do, YYYY") }}
                </time>
              </ul>
            </div>
            <div
              v-html="(latestPost.body || '').split(' ', 50).join(' ')"
            ></div>
          </b-link>
        </div>
        <hr />
      </b-col>
      <b-col cols="12" md="4" class="mb-4"></b-col>
    </b-row>

    <b-row class="container">
      <b-col cols="12" md="8">
        <b-row
          v-for="post in otherLatestPosts"
          :key="post.id"
          class="other-posts mb-3"
        >
          <b-col cols="4" style="padding-left: 0">
            <b-link :to="'/' + category + '/' + post.id">
              <figure class="other-posts_img">
                <b-img fluid :src="post.imgUrl" :alt="post.title"></b-img>
              </figure>
            </b-link>
          </b-col>
          <b-col cols="8" class="other-posts_content">
            <b-link :to="'/' + category + '/' + post.id">
              <div>
                <h3 style="text-transform: capitalize">{{ post.title }}</h3>
                <div class="author-date">
                  <ul>
                    <li>
                      <strong>{{ post.author }}</strong>
                    </li>
                    <time>
                      {{ moment(post.createdAt).format("MMMM Do, YYYY") }}
                    </time>
                  </ul>
                </div>
                <div
                  class="post-body"
                  v-html="(post.body || '').split(' ', 30).join(' ')"
                ></div>
              </div>
            </b-link>
          </b-col>
        </b-row>
        <p v-if="noNewPosts">Không Có Bài Mới</p>
        <b-button v-else @click="tenNextPosts">Đọc Thêm</b-button>
      </b-col>
      <b-col cols="12" md="4"></b-col>
    </b-row>
  </div>
</template>

<script>
import moment from "moment";
import {
  getLatestPostsByCategory,
  getTenNextPostByCategory,
} from "../../firebase/posts";
import { store, STYLES } from "../../firebase/categories";
export default {
  name: "posts-by-category",
  props: {
    category: String,
  },
  data() {
    return {
      latestPost: {},
      otherLatestPosts: [],
      moment,
      store,
      STYLES,
      lastRendedPostTime: null,
      noNewPosts: false,
    };
  },
  watch: {
    category: "load",
  },
  computed: {
    categories() {
      return this.store.categories;
    },
  },
  methods: {
    tenNextPosts() {
      if (!this.lastRendedPostTime) return;
      getTenNextPostByCategory(this.category, this.lastRendedPostTime).then(
        (posts) => {
          if (posts.length) {
            this.otherLatestPosts.push(...posts);
            this.lastRendedPostTime = posts[posts.length - 1].createdAt;
          } else {
            this.noNewPosts = true;
            this.lastRendedPostTime = null;
          }
        }
      );
    },
    load() {
      getLatestPostsByCategory(this.category).then((posts) => {
        window.scrollTo(0, 0);
        this.latestPost = posts[0];
        this.otherLatestPosts = posts.slice(1, posts.length);
        this.lastRendedPostTime = posts[posts.length - 1].createdAt;
        this.noNewPosts = false;
      });
    },
  },
  created() {
    this.load();
  },
};
</script>

<style lang="scss">
@import "../../styles/components/posts/PostsByCategory.scss";
</style>
